import { render, staticRenderFns } from "./MypackNoSearch.vue?vue&type=template&id=2bc0e167&"
import script from "./MypackNoSearch.vue?vue&type=script&lang=js&"
export * from "./MypackNoSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports